// extracted by mini-css-extract-plugin
export default {"page":"page__09d83b12","image":"image__09d83b12","text":"text__09d83b12","description":"description__09d83b12"};